<div *ngIf="!loading">
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="regForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">
					Informações básicas da política
				</span>
			</div>
			<div class="d-f jc-sb ai-c mb-xxs" *ngIf="enableTab">
				<app-tab [tabs]="policiesTabs" (action)="onTabClick($event)"></app-tab>
			</div>
			<div class="d-f line">
				<mat-form-field
					class="col-2"
					title="Nome da política"
					appearance="outline"
				>
					<mat-label>Nome da política</mat-label>
					<input
						type="text"
						matInput
						placeholder="Nome da política"
						formControlName="name"
						id="spn-{{ inputId }}"
					/>
					<mat-error *ngIf="regForm.get('name')?.hasError('required')">
						O nome da política é obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 dyn mob-va"
					title="Forma de contratação"
					appearance="outline"
				>
					<mat-label>Forma de contratação</mat-label>
					<mat-select formControlName="contract">
						<mat-option *ngFor="let com of contractModel" [value]="com.value">
							{{ com.label }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="regForm.get('contract')?.hasError('required')">
						A forma de contratação é obrigatória
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="rulForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">
					Condições de aplicação das regras
				</span>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="c-p col-2"
					title="Cargos"
					appearance="outline"
					(click)="openPositionsModal()"
				>
					<mat-label>Cargos</mat-label>
					<input
						type="text"
						matInput
						class="c-p"
						placeholder="Selecionar benefício"
						id="sfk-{{ inputId }}"
						[value]="positionsInput"
						(focus)="ipick.focus()"
					/>
					<button matSuffix mat-icon-button aria-label="Open positions dialog">
						<mat-icon>arrow_drop_down</mat-icon>
					</button>
				</mat-form-field>
				<input #ipick type="text" class="picker" />
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="mr-xxxs col-1 dyn"
					title="Estado"
					appearance="outline"
				>
					<mat-label>Estado (opcional)</mat-label>
					<mat-select formControlName="state">
						<mat-option [value]="null" (click)="onUFChange(-1)">
							Estado (opcional)
						</mat-option>
						<mat-option
							*ngFor="let s of uf"
							[value]="s.uf"
							(click)="onUFChange(s.id)"
						>
							{{ s.label }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field
					class="col-1 dyn mob-va"
					title="Cidade"
					appearance="outline"
				>
					<mat-label>Cidade (opcional)</mat-label>
					<input
						type="text"
						matInput
						placeholder="Cidade (opcional)"
						formControlName="city"
						id="sxc-{{ inputId }}"
						*ngIf="!auxStateForm"
					/>
					<mat-select formControlName="city" *ngIf="auxStateForm">
						<mat-option [value]="null">Cidade (opcional)</mat-option>
						<mat-option *ngFor="let city of cities" [value]="city">
							{{ city }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="mr-xxxs col-1 dyn"
					title="Salário mínimo"
					appearance="outline"
				>
					<mat-label>Salário mínimo (opcional)</mat-label>
					<span class="input-label" matPrefix>R$ &nbsp;</span>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Salário mínimo (opcional)"
						formControlName="min_wage"
						id="slw-{{ inputId }}"
					/>
				</mat-form-field>
				<mat-form-field
					class="col-1 dyn mob-va"
					title="Salário máximo"
					appearance="outline"
				>
					<mat-label>Salário máximo (opcional)</mat-label>
					<span class="input-label" matPrefix>R$ &nbsp;</span>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Salário máximo (opcional)"
						formControlName="max_wage"
						id="shw-{{ inputId }}"
					/>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="payForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Regras de pagamento</span>
			</div>
			<div class="line">
				<p class="mb-xs lh-md gray">
					Os valores abaixo são a participação por parte do beneficiário. Ex.:
					se colocar R$20,00 ou 20% para o titular significa que ele estes são
					os valores que ele deverá pagar. Se a empresa paga 100% do benefício,
					basta colocar 0 (zero)
				</p>
			</div>
			<div class="d-f mb-xxxs mt-xxs line">
				<mat-form-field
					class="col-1 dyn"
					title="Valor para titular"
					appearance="outline"
				>
					<mat-label>Valor para titular</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor para titular"
						formControlName="owner_value"
						id="sxa-{{ inputId }}"
					/>
					<mat-error *ngIf="payForm.get('owner_value')?.hasError('required')">
						Valor para titular é obrigatório
					</mat-error>
					<button
						matSuffix
						mat-icon-button
						class="suffix-align"
						aria-label="Toggle input type"
						[matMenuTriggerFor]="menuA"
					>
						<p class="d-f fd-r ai-fs">
							<span class="input-label">
								{{ payForm.get('owner_type')?.value }}
							</span>
							<mat-icon svgIcon="sanus-chevron-down-blue"></mat-icon>
						</p>
					</button>
				</mat-form-field>
				<mat-menu #menuA="matMenu">
					<button mat-menu-item (click)="updateInputType('owner_type', 'R$')">
						R$
					</button>
					<button mat-menu-item (click)="updateInputType('owner_type', '%')">
						%
					</button>
				</mat-menu>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 dyn mob-va"
					title="Valor para cônjuge"
					appearance="outline"
				>
					<mat-label>Valor para cônjuge</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor para cônjuge"
						formControlName="spouse_value"
						id="sxb-{{ inputId }}"
					/>
					<button
						matSuffix
						mat-icon-button
						class="suffix-align"
						aria-label="Toggle input type"
						[matMenuTriggerFor]="menuB"
					>
						<p class="d-f fd-r ai-fs">
							<span class="input-label">
								{{ payForm.get('spouse_type')?.value }}
							</span>
							<mat-icon svgIcon="sanus-chevron-down-blue"></mat-icon>
						</p>
					</button>
				</mat-form-field>
				<mat-menu #menuB="matMenu">
					<button mat-menu-item (click)="updateInputType('spouse_type', 'R$')">
						R$
					</button>
					<button mat-menu-item (click)="updateInputType('spouse_type', '%')">
						%
					</button>
				</mat-menu>
			</div>
			<div class="d-f mb-xxxs mt-xxs line">
				<mat-form-field
					class="col-1 dyn"
					title="Valor para 1° dependente"
					appearance="outline"
				>
					<mat-label>Valor para 1° dependente</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor para 1° dependente"
						formControlName="first_dep_value"
						id="sxc-{{ inputId }}"
					/>
					<button
						matSuffix
						mat-icon-button
						class="suffix-align"
						aria-label="Toggle input type"
						[matMenuTriggerFor]="menuC"
					>
						<p class="d-f fd-r ai-fs">
							<span class="input-label">
								{{ payForm.get('first_dep_type')?.value }}
							</span>
							<mat-icon svgIcon="sanus-chevron-down-blue"></mat-icon>
						</p>
					</button>
				</mat-form-field>
				<mat-menu #menuC="matMenu">
					<button
						mat-menu-item
						(click)="updateInputType('first_dep_type', 'R$')"
					>
						R$
					</button>
					<button
						mat-menu-item
						(click)="updateInputType('first_dep_type', '%')"
					>
						%
					</button>
				</mat-menu>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 dyn mob-va"
					title="Valor para 2° dependente"
					appearance="outline"
				>
					<mat-label>Valor para 2° dependente</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor para 2° dependente"
						formControlName="second_dep_value"
						id="sxd-{{ inputId }}"
					/>
					<button
						matSuffix
						mat-icon-button
						class="suffix-align"
						aria-label="Toggle input type"
						[matMenuTriggerFor]="menuD"
					>
						<p class="d-f fd-r ai-fs">
							<span class="input-label">
								{{ payForm.get('second_dep_type')?.value }}
							</span>
							<mat-icon svgIcon="sanus-chevron-down-blue"></mat-icon>
						</p>
					</button>
				</mat-form-field>
				<mat-menu #menuD="matMenu">
					<button
						mat-menu-item
						(click)="updateInputType('second_dep_type', 'R$')"
					>
						R$
					</button>
					<button
						mat-menu-item
						(click)="updateInputType('second_dep_type', '%')"
					>
						%
					</button>
				</mat-menu>
				<mat-form-field
					class="mr-xxxs col-1 dyn mob-va"
					title="Valor para 3° dependente"
					appearance="outline"
				>
					<mat-label>Valor para 3° dependente</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor para 3° dependente"
						formControlName="third_dep_value"
						id="sxe-{{ inputId }}"
					/>
					<button
						matSuffix
						mat-icon-button
						class="suffix-align"
						aria-label="Toggle input type"
						[matMenuTriggerFor]="menuE"
					>
						<p class="d-f fd-r ai-fs">
							<span class="input-label">
								{{ payForm.get('third_dep_type')?.value }}
							</span>
							<mat-icon svgIcon="sanus-chevron-down-blue"></mat-icon>
						</p>
					</button>
				</mat-form-field>
				<mat-menu #menuE="matMenu">
					<button
						mat-menu-item
						(click)="updateInputType('third_dep_type', 'R$')"
					>
						R$
					</button>
					<button
						mat-menu-item
						(click)="updateInputType('third_dep_type', '%')"
					>
						%
					</button>
				</mat-menu>
			</div>
			<div class="d-f mb-xxxs mt-xxs line" *ngIf="!moreDependents">
				<button mat-flat-button color="primary" (click)="moreDependents = true">
					Mais dependentes
				</button>
			</div>
			<div class="d-f mt-xxs line" *ngIf="moreDependents">
				<mat-form-field
					class="col-1 dyn"
					title="Valor para 4° dependente"
					appearance="outline"
				>
					<mat-label>Valor para 4° dependente</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor para 4° dependente"
						formControlName="fourth_dep_value"
						id="sxf-{{ inputId }}"
					/>
					<button
						matSuffix
						mat-icon-button
						class="suffix-align"
						aria-label="Toggle input type"
						[matMenuTriggerFor]="menuF"
					>
						<p class="d-f fd-r ai-fs">
							<span class="input-label">
								{{ payForm.get('fourth_dep_type')?.value }}
							</span>
							<mat-icon svgIcon="sanus-chevron-down-blue"></mat-icon>
						</p>
					</button>
				</mat-form-field>
				<mat-menu #menuF="matMenu">
					<button
						mat-menu-item
						(click)="updateInputType('fourth_dep_type', 'R$')"
					>
						R$
					</button>
					<button
						mat-menu-item
						(click)="updateInputType('fourth_dep_type', '%')"
					>
						%
					</button>
				</mat-menu>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 dyn mob-va"
					title="Valor para 5° dependente"
					appearance="outline"
				>
					<mat-label>Valor para 5° dependente</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor para 5° dependente"
						formControlName="fifth_dep_value"
						id="sxg-{{ inputId }}"
					/>
					<button
						matSuffix
						mat-icon-button
						class="suffix-align"
						aria-label="Toggle input type"
						[matMenuTriggerFor]="menuG"
					>
						<p class="d-f fd-r ai-fs">
							<span class="input-label">
								{{ payForm.get('fifth_dep_type')?.value }}
							</span>
							<mat-icon svgIcon="sanus-chevron-down-blue"></mat-icon>
						</p>
					</button>
				</mat-form-field>
				<mat-menu #menuG="matMenu">
					<button
						mat-menu-item
						(click)="updateInputType('fifth_dep_type', 'R$')"
					>
						R$
					</button>
					<button
						mat-menu-item
						(click)="updateInputType('fifth_dep_type', '%')"
					>
						%
					</button>
				</mat-menu>
				<mat-form-field
					class="mr-xxxs col-1 dyn mob-va"
					title="Valor para 6° dependente"
					appearance="outline"
				>
					<mat-label>Valor para 6° dependente</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor para 6° dependente"
						formControlName="sixth_dep_value"
						id="sxh-{{ inputId }}"
					/>
					<button
						matSuffix
						mat-icon-button
						class="suffix-align"
						aria-label="Toggle input type"
						[matMenuTriggerFor]="menuH"
					>
						<p class="d-f fd-r ai-fs">
							<span class="input-label">
								{{ payForm.get('sixth_dep_type')?.value }}
							</span>
							<mat-icon svgIcon="sanus-chevron-down-blue"></mat-icon>
						</p>
					</button>
				</mat-form-field>
				<mat-menu #menuH="matMenu">
					<button
						mat-menu-item
						(click)="updateInputType('sixth_dep_type', 'R$')"
					>
						R$
					</button>
					<button
						mat-menu-item
						(click)="updateInputType('sixth_dep_type', '%')"
					>
						%
					</button>
				</mat-menu>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="adrForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Regras adicionais</span>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="col-1 dyn"
					title="Idade máxima do filho"
					appearance="outline"
				>
					<mat-label>Idade máxima do filho</mat-label>
					<input
						type="text"
						matInput
						mask="0*"
						placeholder="Idade máxima do filho"
						formControlName="max_age"
						id="sfi-{{ inputId }}"
					/>
					<mat-error *ngIf="adrForm.get('max_age')?.hasError('required')">
						Idade máxima do filho é obrigatória
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 dyn mob-va"
					title="Regra de inclusão"
					appearance="outline"
				>
					<mat-label>Regra de inclusão</mat-label>
					<mat-select
						formControlName="inclusion_rule"
						(valueChange)="onInclusionRuleChange($event)"
					>
						<mat-option
							*ngFor="let rule of inclusionRules"
							[value]="rule.value"
						>
							{{ rule.label }}
						</mat-option>
					</mat-select>
					<mat-error
						*ngIf="adrForm.get('inclusion_rule')?.hasError('required')"
					>
						Regra de inclusão é obrigatória
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-1 dyn mob-va"
					title="Número de dias"
					appearance="outline"
					*ngIf="adrForm.get('inclusion_rule')?.value === 'NUMERO_DIAS'"
				>
					<mat-label>Número de dias</mat-label>
					<input
						type="text"
						matInput
						mask="0*"
						placeholder="Número de dias"
						formControlName="days"
						id="sco-{{ inputId }}"
					/>
					<mat-error *ngIf="adrForm.get('days')?.hasError('required')">
						Insira o número de dias para inclusão
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="d-f jc-fe mb-huge">
		<button
			class="margin-right-16"
			mat-stroked-button
			color="primary"
			routerLink="../"
		>
			Cancelar
		</button>
		<button
			mat-flat-button
			color="primary"
			[disabled]="shouldDisableSaveBtn()"
			(click)="onSubmit()"
		>
			Cadastrar
		</button>
	</div>
</div>
<div class="d-f jc-c ai-c w-100 mt-giant loader" *ngIf="loading">
	<mat-spinner diameter="20"></mat-spinner>
</div>
